import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledLink = styled(Link) `
    color: ${({color}) => color};
    font-weight: ${({ weight}) => weight};
    text-decoration: none;
    margin: ${({ margin}) => margin ? margin : ''};
    width: ${({ width}) => width ? width : ''};
    ${({ scale }) => scale ? `transform: scale(${scale})` : ''}
    ${({ center }) => center ? 'display: flex; justify-content: center' : ''};
    a:hover{
        color: ${({color, hoverColor}) => hoverColor ? hoverColor : color ? color : 'initail' };
    }
    &:focus, &:hover, &:visited, &:link, &:active {
        text-decoration: none;
        color: ${({color, hoverColor}) => hoverColor ? hoverColor : color ? color : 'initail' };
    }
`;

// export default (props) => <StyledLink {...props } onClick={() => window.scrollTo(0,0)}/>;
export default (props) => <StyledLink {...props }/>;


// WEBPACK FOOTER //
// ./src/dev/StyleLink.js